export default __webpack_public_path__ + "static/media/empty-chat-switch.817829bd.svg";